import {Stack} from "@mui/material"
import Typography from "@mui/material/Typography";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const Funds = () => {
    return (
        <Stack direction="row" padding="20px">
            <InfoOutlinedIcon/>
            <Typography>Pagina este în lucru, momentan vă stăm la dispoziție la telefon pentru informații.</Typography>
        </Stack>
    )
}

export default Funds;
